module.exports = __webpack_public_path__ + "img/thumbs_up.62971b1c.jpg";